<script setup lang="ts">
import "./style.css"

interface Props {
  className?: string
  size?: number
}

withDefaults(defineProps<Props>(), {
  class: "",
  size: 100,
})
</script>

<template>
  <div
    :class="[
      className,
      'circles-gradient hidden lg:grid lg:place-items-center',
    ]"
    :style="{ '--circle-size': size + 'px' }"
  >
    <div
      class="big col-span-full row-span-full"
      :style="{
        background: `linear-gradient(
          90deg,
          var(--af-gradient-start-rgb-10) 0%,
          var(--af-gradient-end-rgb-10) 100%
        )`,
      }"
    ></div>
    <div
      class="medium col-span-full row-span-full"
      :style="{
        background: `linear-gradient(
          90deg,
          var(--af-gradient-start-rgb-20) 0%,
          var(--af-gradient-end-rgb-20) 100%
        )`,
      }"
    ></div>
    <div
      class="small col-span-full row-span-full"
      :style="{
        background: `linear-gradient(
          90deg,
          var(--af-gradient-start-rgb-50) 0%,
          var(--af-gradient-end-rgb-50) 100%
        )`,
      }"
    ></div>
  </div>
</template>
